import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { CircularProgress, MenuItem, OutlinedInput, Select, TableCell } from '@material-ui/core'

import { useLogic } from '../../../hooks/storeHook'

import { ensureNumber, valuesOfNumericEnum } from '../../../common/tsUtils'
import { fixMsAppScrollProps } from '../../../common/msAppUtils'

import { MyRowProps } from '../../../types/tableTypes'
import { subscriptionTypeNames } from '../../../types/subscriptionTypeNames'

import { UserModel } from '../../../server/mpsklad_core/Models/UserModel'
import { SubscriptionType } from '../../../server/mpsklad_core/Entity/Enums/SubscriptionType'

export const SubscriptionTypeCell =
  observer(
    ({row}: MyRowProps<UserModel>) => {
      const {setUserSubscription} = useLogic()

      const [isLoading, setIsLoading] = useState(false)

      const classes = useStyles()

      const onChange =
        async (value: unknown) => {
          const subscriptionType: SubscriptionType = ensureNumber(value)

          setIsLoading(true)

          try {
            await setUserSubscription(row.id, subscriptionType)
          } catch (e) {
            console.log('Failed to change subscriptionType', e)
          } finally {
            setIsLoading(false)
          }
        }

      return (
        <TableCell className={clsx('table-border', classes.cell)}>
          {
            isLoading
            ? <CircularProgress size={31}/>
            : <Select
              value={row.subscriptionType}
              onChange={e => onChange(e.target.value)}
              MenuProps={fixMsAppScrollProps}
              fullWidth
              input={<OutlinedInput className={classes.input}/>}
            >
              {
                valuesOfNumericEnum(SubscriptionType).map(value =>
                  <MenuItem key={value} value={value}>
                    {subscriptionTypeNames[value]}
                  </MenuItem>)
              }
            </Select>
          }
        </TableCell>
      )
    })

const useStyles = makeStyles(
  () => ({
    cell: {
      width: 100,
      backgroundColor: 'transparent',
      border: 'none',
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent'
      },
      '& .MuiOutlinedInput-notchedOutline.Mui-focused': {
        border: '1px solid rgba(0, 0, 0, 0.23)'
      }
    },
    input: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '14.4px !important',
      textAlign: 'left',
      height: 35,
      '&.Mui-focused': {
        backgroundColor: 'transparent !important'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px !important',
        borderColor: 'rgba(0, 0, 0, 0.23) !important'
      }
    },
    textField: {
      '& .Mui-disabled': {
        backgroundColor: '#fff',
        color: '#000'
      }
    },
    inputFocused: {
      backgroundColor: 'red !important'
    }
  })
)